import { render, staticRenderFns } from "./checkout-payment-terms.vue?vue&type=template&id=221cb18a&scoped=true"
import script from "./checkout-payment-terms.vue?vue&type=script&lang=js"
export * from "./checkout-payment-terms.vue?vue&type=script&lang=js"
import style0 from "./checkout-payment-terms.vue?vue&type=style&index=0&id=221cb18a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221cb18a",
  null
  
)

export default component.exports